export enum ImageViewerModalMessages {
  CLOSE = 'Close',
  PRINT = 'Print',
}
